export const renderFormErrorMessages = () => "The user settings have not been saved. Please correct the highlighted fields below.";

export const renderSuccessMessage = () => "The user settings have been saved successfully.";
